StepTwoBaseView = require('../base_view')
SupportAPIHelper = require('../../../helpers/API')

class StepTwoCMSBaseView extends StepTwoBaseView
  initialize: ->
    StepTwoBaseView::initialize.apply(this, arguments)

  render: ->
    @categoryRendered = false
    Groupon.Support.ContentModel.onInitStepTwo()
    @hideComponents()
    toggleCallUs(Groupon.Support.CURRENTVIEW.id)
    @flexibleContactChannelModel = Groupon.Support.FlexibleContactChannelModel

  fetchAndRenderCategory : (contentWrapper) ->
    if _.isEmpty(@getDropdowns())
      @spinnerView.show( { container:contentWrapper, append:true, height: '50px' } )
      startTimer("t_dc")
      @dropDownModel.fetch
        data : null
        success: ( model, response, options ) =>
          stopTimer("t_dc")
          @spinnerView.remove()
          @categorySuccessCallback(contentWrapper)
        error: ( model, response, options ) =>
          stopTimer("t_dc")
          @spinnerView.remove()
          @categoryErrorCallback(contentWrapper)
    else
      @categorySuccessCallback(contentWrapper)

  fetchFlexibleContactChannels: (contentWrapper)->
    if @shouldFetchFlexibleContactChannels()
      @flexibleContactChannelsCall = @flexibleContactChannelModel.fetch
        success: ( model, response, options ) =>
          @flexibleContactChannelsCallback(contentWrapper)
        error: ( model, response, options ) =>
          @flexibleContactChannelsCallback(contentWrapper)
    else
      @categorySuccessCallback(contentWrapper)

  flexibleContactChannelsCallback: (contentWrapper)->
    @flexibleContactChannelsCall = null
    @categorySuccessCallback(contentWrapper)

  categorySuccessCallback: (contentWrapper) ->
    if @shouldRenderCategory()
      unless @categoryRendered then @renderCategory(contentWrapper)

  shouldRenderCategory: ()->
    not(_.isEmpty(@getDropdowns()))

  categoryErrorCallback: (model, xhr, options) ->
    @handleAjaxErrors()

  renderSubCategory: (contentWrapper) ->
    @disableAllButton()
    subdropdwn = $('.sub-dropdown', contentWrapper)
    subdropdwn.html("")
    subdropdwn.html toHtml(@subCategoryTemplate, {subCategories: @getSubCategoryList()}, @I18nScope)
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory()
    if contentSubCategory && contentSubCategory != null
      $(".sub-category", contentWrapper).val(contentSubCategory.id)
      # Adding single Quotes because the jquery selector erroring out if the id has punctuation in it
      $(".sub-category option[value='#{contentSubCategory.id}']", contentWrapper).attr("selected", "selected")
      @fetchHelpContent(contentWrapper) unless Groupon.Support.ContentModel.getContent()

  fetchHelpContent: (contentWrapper)->
    if contentWrapper?
      @spinnerView.show({ container:$('.inbenta-content', contentWrapper), height: '50px'  })
    else
      @spinnerView.show({ container:$('.inbenta-content', @$el), height: '50px'  })
    urls = @getHelpContentPaths()
    data = @getTaglines()
    cb = (results) =>
      @helpContentCb(results)
    @contentRequests = SupportAPIHelper.parallel urls, data, cb, false, "t_ic", 60000

  setCategoryToWindow: ->
    @contentRequests = abortAjaxRequests @contentRequests
    @disableAllButton()
    category = @$('.category option:selected').val()
    addToTrackingHub(category, null)
    @clearContentElement()
    if category == ''
      @$(".sub-category option[value='']").attr("selected", "selected");
      @$('.sub-category').trigger('change')
      Groupon.Support.ContentModel.setCategory(null)
      Groupon.Support.ContentModel.setSubCategory(null)
      @clearElement('.sub-dropdown')
    else
      Groupon.Support.ContentModel.setCategory(
        id: @$('.category option:selected').val()
        text: @$('.category option:selected').text()
      )
      Groupon.Support.ContentModel.setSubCategory(null)
      @renderSubCategory(@$el)

  setSubCategoryToWindow: ->
    @contentRequests = abortAjaxRequests @contentRequests
    subcategory = @$('.sub-category option:selected').val()
    @disableAllButton()
    addToTrackingHub(Groupon.Support.ContentModel.getCategory().id, subcategory)
    @clearStepThreeIfPresent()
    @clearContentElement()

    if subcategory == ''
      Groupon.Support.ContentModel.setSubCategory(null)
    else
      Groupon.Support.ContentModel.setSubCategory(
        id: @$('.sub-category option:selected').val()
        text: @$('.sub-category option:selected').text()
        group: @$('.sub-category option:selected')?[0]?.getAttribute "data-group"
      )
      @fetchHelpContent()

  resolveContent: (contents) ->
    unless contents?
      return {}

    possibleStepTwoContentsLength = @getPossibleStepTwoContentsLength()
    for i in [0...possibleStepTwoContentsLength]
      if @isObjectNotEmpty(contents[i])
        contents[i]
        break
    if (i < possibleStepTwoContentsLength and contents[i]?) then contents[i] else {}

  getPossibleStepTwoContentsLength: ()->
    possibleStepTwoNormalContentsLength = 1
    possibleStepTwoNormalContentsLength + @getPriorityTaglinesLength()

  isObjectNotEmpty: (object)->
    not _.isEmpty object

  getPriorityTaglinesLength: ()->
    currentOrderPriorityTaglines = Groupon.Support.currentOrder?.priorityTaglines
    if currentOrderPriorityTaglines? then currentOrderPriorityTaglines.length else 0

  resolveFlexStepThree: (contents) ->
    unless contents?
      return
    flexStepThreeStartIndex = @getFlexStepThreeStartIndex contents

    for i in [flexStepThreeStartIndex...contents.length]
      if @isObjectNotEmpty(contents[i])
        contents[i]
        break
    if (i < contents.length) then contents[i]

  getPossibleFlexStepThreeContentsLength: (contents)->
    possibleNormalFlexStepThreeContentsLength = 1
    possibleNormalFlexStepThreeContentsLength + @getPriorityTaglinesLength()

  getFlexStepThreeStartIndex: (contents)->
    (contents.length - @getPossibleFlexStepThreeContentsLength contents)

  setPriorityContentFlags: (contents)->
    @setIsRefundEligibleFlag contents
    @setEscalateToMerchantFlag contents

  setIsRefundEligibleFlag: (contents)->
    Groupon.Support.ContentModel.isRefundEligible = @isRefundEligibleFlexStepThreePresent(contents)

  setEscalateToMerchantFlag: (contents)->
    Groupon.Support.ContentModel.escalateToMerchant = @isEscalateToMerchantFlexStepThreePresent(contents)
    @prioritizeRefundEligibleOverMerchantEscalation()

  prioritizeRefundEligibleOverMerchantEscalation: ()->
    if evaluate(Groupon.Support.ContentModel.isRefundEligible) then Groupon.Support.ContentModel.escalateToMerchant = false

  isRefundEligibleFlexStepThreePresent: (contents)->
    evaluate(Groupon.Support.currentOrder?.isRefundEligible) and @isObjectNotEmpty contents[@getFlexStepThreeStartIndex(contents)]

  isEscalateToMerchantFlexStepThreePresent: (contents)->
    evaluate(Groupon.Support.currentOrder?.escalateToMerchant) and @isObjectNotEmpty contents[contents.length-2]

  enableTicketDirectionButton: () ->
    @sendTrackyCallForHelpContentBeingShown false
    @$('.issue-check').hide()
    @handleDisplayOfTicketDirectionButtons()

  handleDisplayOfTicketDirectionButtons: ()->
    if evaluate(Groupon.Support.ContentModel.isRefundEligible)
      @enableRefundRequestButton()
    else
      @enableContinueToEmailButton()

  enableResolvedButton: () ->
    @sendTrackyCallForHelpContentBeingShown true
    if evaluate(Groupon.Support.ContentModel?.isRefundEligible)
      return @enableTicketDirectionButton()
    @$('.issue-check').show()
    @$('.refund-my-request').hide()
    @$('.direct-ticket').hide()

  enableRefundRequestButton: () ->
    @$('.refund-my-request').show()
    @$('.direct-ticket').hide()

  enableContinueToEmailButton: () ->
    @$('.refund-my-request').hide()
    @$('.direct-ticket').show()

  helpContentCb: (results) ->
    if results?
      @helpContentSuccess(results)
    else
      @helpContentError()

  checkIfTextHasClickToContinueSubString : (text) ->
    return text? && (text.indexOf('"Continue"') > -1)

  getHelpContentPaths: ->
    url = "#{window.SUPPORTBASEURL}/fetch?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}"
    urls = [url, url]
    @addUrlsForPriorityContentAndFlexStepThree(urls)
    urls

  addUrlsForPriorityContentAndFlexStepThree: (urls)->
    if Groupon.Support.currentOrder?.priorityTaglines?
      #2 Times because one for priority step-two content and the other for flex step three
      noOfPriorityUrls = 2*Groupon.Support.currentOrder.priorityTaglines.length
      for i in [0...noOfPriorityUrls]
        urls.push urls[0]

    urls

  getTaglines: ->
    tagLines = []
    tagLinesBase = "#{@getCategoryId()},#{@getSubCategoryId()}"
    tagLine = "#{tagLinesBase},#{@tagLine}"

    stepThreeTagline = { key: tagLine, base: "helpwizard_email_form", type:"flexible_step_three" }
    contentTagline = { key: tagLine, base: "helpwizard_content", type:"content"}

    @setPriorityTaglinesForContent tagLines, contentTagline, tagLinesBase
    tagLines.push contentTagline
    @setPriorityTaglinesForStepThree tagLines, stepThreeTagline, tagLinesBase
    tagLines.push stepThreeTagline

    tagLines

  isPriorityTaglinesPresent: ->
    Groupon.Support.currentOrder?.priorityTaglines?.length > 0

  setPriorityTaglinesForGenericTagline: (tagLinesData, taglineData, baseTagline) ->
    if @isPriorityTaglinesPresent()
      priorityTaglines = Groupon.Support.currentOrder.priorityTaglines
      _.each(priorityTaglines, (priorityTagline) ->
        priorityTaglineData = $.extend(true, {}, taglineData)
        priorityTaglineData.key = "#{baseTagline},#{priorityTagline}"
        tagLinesData.push(priorityTaglineData)
      )

  setPriorityTaglinesForStepThree: (tagLinesData, stepThreeTaglineData, baseTagline) ->
    @setPriorityTaglinesForGenericTagline tagLinesData, stepThreeTaglineData, baseTagline

  setPriorityTaglinesForContent: (tagLinesData, contentTaglineData, baseTagline) ->
    @setPriorityTaglinesForGenericTagline tagLinesData, contentTaglineData, baseTagline

module.exports = StepTwoCMSBaseView
